import FieldFormatter from "components/Records/Formatters/FieldFormatter";
import MergeCheckbox from "./MergeCheckbox";

const SelectedRecordInput = ({
  field,
  item,
  value,
  moduleAPIName,
  isSelected,
  hideColor = true,
  onClick,
  disabled,
}) => {
  return (
    <div
      className="d-flex align-items-center overflow-hidden ml--1 mr--3 pr-1 rounded py-1"
      style={{
        backgroundColor: hideColor
          ? undefined
          : isSelected
          ? "var(--dropdown-selected)"
          : "#FFF",
        border: hideColor
          ? undefined
          : isSelected
          ? "2px solid var(--dropdown-selected-dark)"
          : "2px solid var(--superlight)",
      }}
    >
      <MergeCheckbox
        isSelected={isSelected}
        disabled={disabled}
        onClick={onClick}
      />
      <div className="w-100">
        <FieldFormatter
          record={item}
          recordID={item?.id}
          field={field}
          value={value}
          forceReadOnly={true}
          moduleAPIName={moduleAPIName}
        />
      </div>
    </div>
  );
};

export default SelectedRecordInput;
